export const generateRoadmapHTML = (roadmap) => {
    if (!roadmap) return '';

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${roadmap.role} - Interactive Roadmap</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    <script>
        tailwind.config = {
            theme: {
                extend: {
                    colors: {
                        primary: { 50: '#eff6ff', 100: '#dbeafe', 500: '#3b82f6', 600: '#2563eb', 700: '#1d4ed8' },
                        secondary: { 50: '#f0f9ff', 100: '#e0f2fe', 500: '#0ea5e9' }
                    },
                    animation: {
                        'fade-in-up': 'fadeInUp 0.6s ease-out',
                        'blob': 'blob 7s infinite'
                    },
                    keyframes: {
                        fadeInUp: { '0%': { opacity: '0', transform: 'translateY(20px)' }, '100%': { opacity: '1', transform: 'translateY(0)' } },
                        blob: { '0%': { transform: 'translate(0px, 0px) scale(1)' }, '33%': { transform: 'translate(30px, -50px) scale(1.1)' }, '66%': { transform: 'translate(-20px, 20px) scale(0.9)' }, '100%': { transform: 'translate(0px, 0px) scale(1)' } }
                    }
                }
            }
        }
    </script>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        body { font-family: 'Inter', sans-serif; }
        .gradient-text { background: linear-gradient(to right, #2563eb, #0ea5e9); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .glass-card { background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px); }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    </style>
</head>
<body class="bg-gray-50 min-h-screen py-12 px-4 sm:px-6">
    <div class="max-w-4xl mx-auto">
        <!-- Header -->
        <div class="text-center mb-16 animate-fade-in-up">
            <div class="inline-flex items-center px-4 py-2 bg-indigo-100 text-indigo-700 rounded-full text-sm font-medium mb-6">
                <i class="fas fa-road mr-2"></i> Interactive Learning Path
            </div>
            <h1 class="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
                ${roadmap.role} <span class="gradient-text">Roadmap</span>
            </h1>
            <p class="text-xl text-gray-600 max-w-2xl mx-auto">${roadmap.description}</p>
            <div class="flex justify-center mt-6 gap-4">
               <span class="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-white border border-gray-200 text-gray-700 shadow-sm">
                 <i class="far fa-clock mr-2 text-indigo-500"></i> ${roadmap.estimatedDuration}
               </span>
            </div>
        </div>

        <!-- Roadmap Timeline -->
        <div class="relative max-w-4xl mx-auto space-y-8">
            <div class="absolute left-6 md:left-8 top-8 bottom-8 w-0.5 bg-gray-200"></div>

            ${roadmap.roadmap.map((phase, index) => `
            <div class="relative pl-16 md:pl-24 animate-fade-in-up" style="animation-delay: ${index * 0.1}s">
                <!-- Connector -->
                <div class="absolute left-6 md:left-8 -translate-x-1/2 top-8 w-4 h-4 rounded-full bg-indigo-600 border-4 border-white shadow-sm z-10"></div>
                
                <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300">
                    <!-- Header -->
                    <div class="p-6 cursor-pointer hover:bg-gray-50/50 transition-colors" onclick="togglePhase(${index})">
                        <div class="flex justify-between items-start">
                            <div class="flex items-start gap-4">
                                <div class="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold text-sm shrink-0 mt-1">
                                    ${index + 1}
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-900">${phase.phase}</h3>
                                    <div class="flex flex-wrap items-center gap-2 mt-2 text-sm text-gray-500">
                                        <span class="px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">${phase.level}</span>
                                        <span>•</span>
                                        <span><i class="far fa-clock mr-1"></i> ${phase.duration}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-4 text-gray-400 transition-transform duration-300" id="icon-${index}">
                                <i class="fas fa-chevron-down"></i>
                            </div>
                        </div>
                         <div class="mt-3 ml-12 flex items-center text-sm font-medium text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-100 w-fit">
                            <i class="fas fa-trophy mr-2 text-emerald-500"></i>
                            ${phase.outcome}
                         </div>
                    </div>

                    <!-- Content (Collapsible) -->
                    <div id="content-${index}" class="hidden opacity-0 transition-all duration-300 ease-in-out">
                         <div class="px-6 pb-8 pt-2 border-t border-gray-100 bg-gray-50/30">
                            
                            <!-- Skills -->
                            <h4 class="text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 flex items-center mt-6">
                                <i class="fas fa-brain mr-2"></i> Skills & Topics
                            </h4>
                            <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-8">
                                ${phase.skills.map(skill => `
                                <div class="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                                    <h5 class="font-bold text-gray-900 mb-2 flex items-center">
                                       <span class="w-1.5 h-1.5 rounded-full bg-indigo-500 mr-2"></span> ${skill.name}
                                    </h5>
                                    <ul class="space-y-2 pl-4 border-l-2 border-gray-100">
                                        ${skill.topics.map(t => {
                                            if (typeof t === 'string') return `<li class="text-sm text-gray-600">${t}</li>`;
                                            return `
                                                <li class="text-sm text-gray-600">
                                                    <div class="font-semibold text-gray-800">${t.title}</div>
                                                    ${t.description ? `<p class="text-xs text-gray-500 mt-0.5">${t.description}</p>` : ''}
                                                    ${t.subtopics && t.subtopics.length > 0 ? `
                                                        <ul class="ml-2 mt-1 space-y-0.5 border-l border-indigo-100 pl-2">
                                                            ${t.subtopics.map(sub => `<li class="text-xs text-slate-500">• ${sub}</li>`).join('')}
                                                        </ul>
                                                    ` : ''}
                                                </li>
                                            `;
                                        }).join('')}
                                    </ul>
                                </div>
                                `).join('')}
                            </div>

                            <!-- Weekly Breakdown -->
                            ${phase.weeklyBreakdown && phase.weeklyBreakdown.length ? `
                            <div class="mb-8">
                                <h4 class="text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 flex items-center">
                                    <i class="fas fa-calendar-week mr-2"></i> Weekly Breakdown
                                </h4>
                                <div class="space-y-3">
                                    ${phase.weeklyBreakdown.map(week => `
                                    <div class="bg-blue-50/30 p-4 rounded-xl border border-blue-100">
                                        <div class="flex items-center mb-2">
                                            <span class="w-8 h-8 rounded-full bg-white text-indigo-600 font-bold flex items-center justify-center text-xs shadow-sm mr-3 border border-indigo-100">W${week.week}</span>
                                            <div>
                                                <h5 class="font-bold text-gray-900 text-sm">${week.focus}</h5>
                                                <span class="text-xs text-gray-500"><i class="far fa-clock mr-1"></i> ${week.hoursRequired}</span>
                                            </div>
                                        </div>
                                        
                                        <div class="ml-11">
                                            <ul class="space-y-1 mb-2">
                                                ${week.tasks.map(task => `<li class="text-xs text-gray-600 flex items-start"><i class="fas fa-check-circle text-green-500/70 mr-2 mt-0.5"></i> ${task}</li>`).join('')}
                                            </ul>
                                            ${week.milestone ? `
                                                <div class="bg-white px-3 py-2 rounded-lg border border-yellow-100 flex items-start">
                                                    <i class="fas fa-trophy text-yellow-500 mr-2 mt-0.5 text-xs"></i>
                                                    <span class="text-xs font-medium text-gray-700">${week.milestone}</span>
                                                </div>
                                            ` : ''}
                                        </div>
                                    </div>
                                    `).join('')}
                                </div>
                            </div>
                            ` : ''}

                            <!-- Action Items -->
                            ${phase.actionItems && phase.actionItems.length ? `
                            <div class="mb-8">
                                <h4 class="text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 flex items-center">
                                    <i class="fas fa-exclamation-circle mr-2"></i> What To Do Next
                                </h4>
                                <div class="grid gap-3 grid-cols-1 md:grid-cols-2">
                                    ${phase.actionItems.map((item, i) => `
                                    <div class="p-3 rounded-xl border flex items-start ${item.priority === 'high' ? 'bg-red-50/50 border-red-100' : item.priority === 'medium' ? 'bg-amber-50/50 border-amber-100' : 'bg-emerald-50/50 border-emerald-100'}">
                                        <div class="flex-1">
                                            <div class="flex justify-between items-start mb-1">
                                                 <span class="text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide ${item.priority === 'high' ? 'bg-red-100 text-red-600' : item.priority === 'medium' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}">${item.priority}</span>
                                                 ${item.timeEstimate ? `<span class="text-[10px] text-gray-400"><i class="far fa-clock mr-1"></i>${item.timeEstimate}</span>` : ''}
                                            </div>
                                            <p class="text-xs font-semibold text-gray-800 leading-snug">${item.task}</p>
                                        </div>
                                    </div>
                                    `).join('')}
                                </div>
                            </div>
                            ` : ''}

                             <!-- Projects -->
                            ${phase.projects && phase.projects.length ? `
                            <div class="mb-8">
                                <h4 class="text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 flex items-center">
                                    <i class="fas fa-laptop-code mr-2"></i> Practical Projects
                                </h4>
                                <div class="grid gap-4 grid-cols-1 md:grid-cols-2">
                                     ${phase.projects.map(p => `
                                     <div class="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-5 border border-indigo-100">
                                        <h5 class="font-bold text-gray-900 mb-1">${p.name}</h5>
                                        <p class="text-sm text-gray-600">${p.description}</p>
                                     </div>
                                     `).join('')}
                                </div>
                            </div>
                            ` : ''}

                            <!-- Resources -->
                            ${phase.resources && phase.resources.length ? `
                            <div>
                                <h4 class="text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 flex items-center">
                                    <i class="fas fa-video mr-2"></i> Resources
                                </h4>
                                <div class="flex flex-wrap gap-3">
                                    ${phase.resources.map(r => `
                                    <a href="${r.url}" target="_blank" class="inline-flex items-center px-4 py-2 rounded-lg bg-white border border-gray-200 text-indigo-600 hover:text-indigo-700 hover:border-indigo-300 hover:shadow-sm transition-all text-sm font-medium">
                                        ${r.name} <i class="fas fa-external-link-alt ml-2 text-xs opacity-70"></i>
                                    </a>
                                    `).join('')}
                                </div>
                            </div>
                            ` : ''}
                         </div>
                    </div>
                </div>
            </div>
            `).join('')}
        </div>

        <!-- Master Project -->
        ${roadmap.masterProject ? `
        <div class="mt-16 bg-gradient-to-br from-gray-900 to-indigo-900 rounded-3xl shadow-xl overflow-hidden text-white relative p-8 md:p-12 text-center animate-fade-in-up">
            <div class="absolute top-0 right-0 -mt-10 -mr-10 w-64 h-64 bg-indigo-500 rounded-full opacity-20 filter blur-3xl animate-blob"></div>
             <div class="absolute bottom-0 left-0 -mb-10 -ml-10 w-64 h-64 bg-purple-500 rounded-full opacity-20 filter blur-3xl animate-blob" style="animation-delay: 2s"></div>
            
             <div class="relative z-10">
                <div class="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white/10 backdrop-blur-md mb-8 ring-1 ring-white/20">
                    <i class="fas fa-trophy text-4xl text-yellow-400"></i>
                </div>
                <h2 class="text-3xl md:text-5xl font-extrabold mb-6">Master Capstone Project</h2>
                <h3 class="text-2xl font-bold mb-4">${roadmap.masterProject.title}</h3>
                <p class="text-indigo-100 text-lg mb-10 max-w-3xl mx-auto">${roadmap.masterProject.description}</p>
                
                <div class="bg-white/5 rounded-2xl p-6 backdrop-blur-sm max-w-3xl mx-auto border border-white/10">
                     <h4 class="text-sm font-bold uppercase tracking-wider text-indigo-200 mb-4">Tech Stack</h4>
                     <div class="flex flex-wrap justify-center gap-3">
                        ${roadmap.masterProject.techStack.map(t => `
                        <span class="px-4 py-2 bg-white/10 rounded-xl text-sm font-medium border border-white/10 shadow-sm">${t}</span>
                        `).join('')}
                     </div>
                </div>
             </div>
        </div>
        ` : ''}

        <footer class="mt-16 text-center text-gray-500 text-sm">
            <p>Generated by Gaplify • ${new Date().toLocaleDateString()}</p>
        </footer>
    </div>

    <script>
        function togglePhase(index) {
            const content = document.getElementById('content-' + index);
            const icon = document.getElementById('icon-' + index);
            
            if (!content.classList.contains('hidden')) {
                // Collapse
                content.style.maxHeight = content.scrollHeight + 'px'; // Set current height first for transition
                setTimeout(() => {
                    content.style.maxHeight = '0px';
                    content.style.opacity = '0';
                }, 10);
                setTimeout(() => {
                     content.classList.add('hidden');
                }, 300);
                icon.style.transform = 'rotate(0deg)';
            } else {
                // Expand
                content.classList.remove('hidden');
                setTimeout(() => {
                     content.style.maxHeight = content.scrollHeight + 'px';
                     content.style.opacity = '1';
                }, 10);
                setTimeout(() => {
                    content.style.maxHeight = 'none'; // Allow it to grow if needed
                }, 310);
                icon.style.transform = 'rotate(180deg)';
            }
        }
    </script>
</body>
</html>
    `;
};
